import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

export function* handleVerifyUserAndSetPassword({ payload }) {
  try {
    const res = yield call(API.verifyUserAndSetPassword, payload);
    const { data } = res;
    yield put(actions.verifyUserAndSetPasswordSuccess(data));
    payload.onSuccess();
  } catch (err) {
    console.log(err);
    if (err?.response?.status === 400) {
      yield put(
        actions.verifyUserAndSetPasswordFailure({
          message: "The link used for verification of account is expired!!",
        })
      );
    } else
      yield put(actions.verifyUserAndSetPasswordFailure(err?.response?.data));
    // payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* verifyUserSaga() {
  yield takeLatest(
    actions.verifyUserAndSetPassword.type,
    handleVerifyUserAndSetPassword
  );
}
